import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3337/consumer/offer";
};

export const loadVoucherDetail = (id) => {
  const url = `${baseURL()}/detail/${id !== null ? id : ""}`;
  return axios.get(url);
};

export const loadMyVoucher = (params) => {
  const url = `${baseURL()}/myVoucher`;
  return axios.post(url, params);
};

export const loadMyVoucherDetail = (id) => {
  const url = `${baseURL()}/myvoucher/detail/${id !== null ? id : ""}`;
  return axios.get(url);
};

export const loadVoucherFoodMedia = (params) => {
  const url = `${baseURL()}/${params.id}/album/${params.offset}/${
    params.limit
  }`;
  return axios.get(url);
};

export const loadVoucherList = (params, restID, status) => {
  const url = `${baseURL()}/load${
    restID !== null
      ? status !== null
        ? "/" + restID + "/" + status
        : "/" + restID
      : ""
  }`;
  return axios.post(url, params);
};

export const refundVoucher = (params) => {
  const url = `${baseURL()}/refund/${params.id}`;
  return axios.post(url, params);
};

export const redeemedVoucher = (params) => {
  const url = `${baseURL()}/redeem/${params.rid}/${params.id}/${params.vid}`;
  return axios.post(url, params);
};

export const buyVoucher = (params) => {
  const url = `${baseURL()}/getOffer`;
  return axios.post(url, params);
};

export const loadPromo = (params) => {
  // search_method: 1
  // >> same params as loadVoucher
  // >> extra ~ selected_voucher and promo_code
  // search_method: 2
  // >> extra ~ promo_code
  const url = `${baseURL()}/checkPromoAvailability`;
  return axios.post(url, params);
};
